import Fuzzy from "@leeoniya/ufuzzy"

export const DEFAULT_FUZZY_SEARCH_OPTIONS: Fuzzy.Options = {
  intraMode: 1
}
